import { render, staticRenderFns } from "./EditCredenciamento.vue?vue&type=template&id=6ac9fddd"
import script from "./EditCredenciamento.vue?vue&type=script&lang=js"
export * from "./EditCredenciamento.vue?vue&type=script&lang=js"
import style0 from "./EditCredenciamento.vue?vue&type=style&index=0&id=6ac9fddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports